export const ORDER_SORTING_DETAILS = {
  READY: 'Ready',
  IN_PROGRESS: 'In Progress',
};
